import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaExchangeAlt, FaGuitar, FaTools, FaPaintBrush, FaArrowRight, FaCheck, FaCrown, FaGem } from 'react-icons/fa';

const Siparis = () => {
  const whatsappNumber = "905308648486";
  const [selectedOption, setSelectedOption] = useState('custom');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    window.scrollTo(0, 0);
    
    return () => {
      setMounted(false);
    };
  }, []);

  const customMessage = encodeURIComponent(`Merhaba! Neo Guitar Custom Shop'dan gitar siparişi vermek istiyorum.

İstediğim özellikler:
• Gitar Tipi: [Strat/Les Paul/Tele vb.]
• Gövde Ağacı: 
• Sap Ağacı:
• Manyetikler: 
• Renk/Boya: 
• Diğer Özellikler:

Bütçem: 
Teslim Süresi: 

İletişim Bilgilerim:
Ad Soyad: 
Telefon: 
E-posta: 

Notlarım:`);

  const tradeMessage = encodeURIComponent(`Merhaba! Elektro gitar takası yapmak istiyorum.

TAKAS YAPMAK İSTEDİĞİM GİTAR:
• Marka/Model:
• Yıl:
• Durumu:
• Fotoğraf/Var mı: [Evet/Hayır]

ALMAK İSTEDİĞİM GİTAR:
• Marka/Model Tercihim:
• Bütçe Katkım:

İletişim Bilgilerim:
Ad Soyad: 
Telefon: 
E-posta: 
Şehir: 

Gitarımın Fotoğraflarını WhatsApp'tan göndereceğim.`);

  const openWhatsapp = (message) => {
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  const options = [
    {
      id: 'custom',
      title: 'Custom Gitar Siparişi',
      icon: FaGuitar,
      description: 'Hayalinizdeki custom elektro gitarı birlikte tasarlayalım. Malzeme seçiminden boya işlemlerine kadar her detayda yanınızdayız.',
      features: [
        'Kişiye özel tasarım',
        'El işçiliği',
        'Premium malzemeler',
        'Sınırsız renk seçeneği',
        'Profesyonel setup',
        '2 yıl garanti'
      ],
      buttonText: 'Custom Gitar İçin Yaz',
      message: customMessage
    },
    {
      id: 'trade',
      title: 'Elektro Gitar Takası',
      icon: FaExchangeAlt,
      description: 'Mevcut elektro gitarınızı değerlendirip, yeni bir custom gitar ile takas edelim.',
      features: [
        'Ücretsiz ekspertiz',
        'Adil değerleme',
        'Yeni custom gitar',
        'Takas + nakit seçeneği',
        'Teslimat hizmeti',
        'Garanti transferi'
      ],
      buttonText: 'Takas İçin Yaz',
      message: tradeMessage
    }
  ];

  // Sayfa yüklenene kadar basit bir loading
  if (!mounted) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900" />
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white overflow-hidden">
      <div className="pt-20 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className="inline-flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-gray-700/30 to-gray-800/30 rounded-full mb-6 backdrop-blur-sm border border-gray-700/50">
                <FaCrown className="text-amber-400" />
                <span className="text-gray-300 font-semibold">NEO GUITAR CUSTOM SHOP</span>
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                <span className="block">Sadece Size Özel</span>
                <span className="block bg-gradient-to-r from-amber-400 via-orange-400 to-amber-300 bg-clip-text text-transparent">
                  Custom Elektro Gitar
                </span>
              </h1>
              
              <p className="text-gray-400 text-lg md:text-xl max-w-3xl mx-auto mb-10 leading-relaxed">
                Standart gitarlardan sıkıldınız mı? Hayalinizdeki gitarı birlikte tasarlayalım. 
                Elektro gitar takas hizmetimizle mevcut gitarınızı değerlendirelim.
              </p>
            </motion.div>
          </div>

          {/* Options Selection */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
            {options.map((option, index) => (
              <motion.div
                key={option.id}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className={`relative p-8 rounded-2xl backdrop-blur-sm border-2 transition-all duration-300 cursor-pointer ${
                  selectedOption === option.id 
                    ? 'border-amber-500/50 bg-gradient-to-br from-gray-800/60 to-gray-900/60 shadow-2xl shadow-amber-500/10'
                    : 'border-gray-700/50 bg-gradient-to-br from-gray-800/30 to-gray-900/30 hover:border-amber-500/30'
                }`}
                onClick={() => setSelectedOption(option.id)}
              >
                <div className="relative z-10">
                  <div className="flex items-center gap-4 mb-6">
                    <div className={`p-4 rounded-xl ${
                      selectedOption === option.id 
                        ? 'bg-gradient-to-br from-amber-500/20 to-orange-500/20' 
                        : 'bg-gray-800/50'
                    }`}>
                      <option.icon className="text-3xl" />
                    </div>
                    <h3 className="text-2xl font-bold">{option.title}</h3>
                  </div>
                  
                  <p className="text-gray-400 mb-8 leading-relaxed">
                    {option.description}
                  </p>
                  
                  <div className="grid grid-cols-2 gap-3 mb-8">
                    {option.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <FaCheck className="text-amber-400 text-sm" />
                        <span className="text-sm text-gray-300">{feature}</span>
                      </div>
                    ))}
                  </div>
                  
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      openWhatsapp(option.message);
                    }}
                    className={`w-full py-4 rounded-xl font-bold flex items-center justify-center gap-3 transition-all duration-300 ${
                      selectedOption === option.id
                        ? 'bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600'
                        : 'bg-gray-800 hover:bg-gray-700'
                    }`}
                  >
                    <FaWhatsapp className="text-2xl" />
                    {option.buttonText}
                    <FaArrowRight className="transition-transform group-hover:translate-x-1" />
                  </button>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Process Steps */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="mb-20"
          >
            <h2 className="text-3xl font-bold text-center mb-12">
              Nasıl Çalışır?
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              {[
                {
                  step: "01",
                  title: "WhatsApp'tan Yaz",
                  description: "Hangi hizmeti istediğinizi yazın",
                  icon: FaWhatsapp
                },
                {
                  step: "02",
                  title: "Detayları Konuş",
                  description: "Özellikleri ve detayları birlikte belirleyelim",
                  icon: FaTools
                },
                {
                  step: "03",
                  title: "Tasarım & Fiyat",
                  description: "Size özel tasarım ve teklif sunalım",
                  icon: FaPaintBrush
                },
                {
                  step: "04",
                  title: "Üretim & Teslimat",
                  description: "Gitarınızı üretip kapınıza getirelim",
                  icon: FaGem
                }
              ].map((step, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.3 + (index * 0.1) }}
                  className="text-center"
                >
                  <div className="relative mb-6">
                    <div className="w-20 h-20 mx-auto bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl flex items-center justify-center border border-gray-700/50">
                      <step.icon className="text-amber-400 text-3xl" />
                    </div>
                    <div className="absolute -top-3 -right-3 w-8 h-8 bg-gradient-to-br from-amber-500 to-orange-500 rounded-full flex items-center justify-center text-sm font-bold">
                      {step.step}
                    </div>
                  </div>
                  <h3 className="text-xl font-bold mb-2">{step.title}</h3>
                  <p className="text-gray-400 text-sm">{step.description}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* CTA */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="text-center p-8 rounded-2xl bg-gradient-to-br from-gray-800/40 to-gray-900/40 backdrop-blur-sm border border-gray-700/50"
          >
            <h2 className="text-2xl md:text-3xl font-bold mb-4">
              Hemen WhatsApp'tan Yazın
            </h2>
            <p className="text-gray-400 mb-6 max-w-2xl mx-auto">
              Aklınızda soru kalmadan, direkt olarak bizimle iletişime geçin. 
              Custom gitar veya takas için en doğru adrestesiniz.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => openWhatsapp(customMessage)}
                className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 px-8 py-4 rounded-xl font-bold text-lg transition-all hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl"
              >
                <FaWhatsapp className="text-2xl" />
                Custom Gitar İçin Yaz
              </button>
              
              <button
                onClick={() => openWhatsapp(tradeMessage)}
                className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-gray-800 to-gray-900 hover:from-gray-900 hover:to-black border border-gray-700/50 px-8 py-4 rounded-xl font-bold text-lg transition-all hover:scale-105 active:scale-95"
              >
                <FaExchangeAlt className="text-2xl" />
                Takas İçin Yaz
              </button>
            </div>
            
            <p className="text-gray-500 text-sm mt-6">
              Ortalama cevap süresi: <span className="text-green-400">5 dakika</span>
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Siparis;